<template>
  <div class="returnAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>系统配置信息 </div>
        </template>
        <div class="collapse-content">
          <base-form ref="baseForm" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div v-if="$route.query.type != 'query'" class="fixed-bottom-btnList">
      <el-button type="primary" @click="save()" :loading="loading" class="fixed-bottom-btn"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
  import baseForm from './components/baseForm'; // 开户行信息
  import API from '@/api/systemManage/sysConfig';
  // import { resolve, reject } from 'q';

  export default {
    name: 'returnAdd',
    components: {
      baseForm,
    },
    data() {
      return {
        loading: false,
        activeNames: ['1'],
      };
    },
    computed: {},
    mounted() {
      if (this.$route.query.type) {
        this.getDetail();
      }
    },
    methods: {
      // 请求详情
      getDetail() {
        this.loading = true;
        const params = {
          id: this.$route.query.id,
        };
        this.$axios.post(API.QUERY_SYSCONFIG_BY_ID, params).then((res) => {
          if (res.data.code == 0) {
            this.loading = false;
            let data = res.data.data;
            let baseForm = this.$refs.baseForm.baseData;
            Object.keys(baseForm).map((item) => {
              return (baseForm[item] = data[item]);
            });
          }
        });
      },
      save() {
        let params = {};
        let baseForm = this.$refs['baseForm'].exportChildData();
        if (baseForm) {
          params = {
            ...baseForm,
          };
        } else {
          return;
        }
        if (this.$route.query.id) {
          params = {
            ...params,
            id: this.$route.query.id,
          };
        }
        this.saveData(params);
      },
      saveData(params) {
        this.loading = true;
        // 保存提交
        this.$axios.post(API.SAVE_SYSCONFIG, params).then((res) => {
          this.loading = false;
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success',
            });
            this.returnPath();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/system/sysConfigAdd',
            name: 'sysConfigAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/system/sysConfig',
            name: 'sysConfig',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
